import { render } from "./DetachedNavigatieStappen.vue?vue&type=template&id=509c24b8"
import script from "./DetachedNavigatieStappen.vue?vue&type=script&lang=js"
export * from "./DetachedNavigatieStappen.vue?vue&type=script&lang=js"

import "./DetachedNavigatieStappen.vue?vue&type=style&index=0&id=509c24b8&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__